import axios from "axios";
import { CldContext, CldImage } from "cloudinary-vue";

export default {
  name: "articleModal",
  components: {
    CldContext,
    CldImage,
  },
  props: ["productDetail"],
  data() {
    return {
      colorImg: "",
      modelDescription: "",
      modelPrice: "",
      modelTitle: "",
      modelImage0: "",
      modelImage1: "",
      modelImage2: "",
      modelImage3: "",
      sortedData: [],
      modelDisponible: "",
      quantiteMax: 1,
      quantiteMin: 1,
      btnValue: "",
      selectDetailsSize: "",
      detailsElement: [],
      detailsElementSize: [],
      detailsElementPointure: [],
      detailsElementDimmension: [],
      dimmensionLargeur: 0,
      dimmensionLongueur: 0,
      maxW: 0,
      maxH: 0,
      idSelectedElement: "",
      subId: "",
      // sizeProduct:["x","y"],
      model: {
        quantite: 1,
      },
      activePrompt2: true,
      popupActivo2: true,
    };
  },
  async created() {
    this.modelContent();
  },
  computed: {},
  methods: {
    acceptAlert() {},
    close() {
      this.$store.state.product.productModalState = false;
    },

    getValueDimmension(type) {
      if (type == "1") {
        if (
          this.detailsElementDimmension[0].widthMax < this.dimmensionLargeur ||
          this.detailsElementDimmension[0].widthMin > this.dimmensionLargeur
        ) {
          // this.$toast.open({
          //   message:
          //     "Largeur maximal est " +
          //     this.detailsElementDimmension[0].widthMax,
          //   type: "error",
          //   // position: "top-right",
          //   // all of other options may go here
          // });
        }
      } else {
        if (
          this.detailsElementDimmension[0].heightMax <
            this.dimmensionLongueur ||
          this.detailsElementDimmension[0].heightMin > this.dimmensionLongueur
        ) {
          // this.$toast.open({
          //   message:
          //     "Longeur maximal est " +
          //     this.detailsElementDimmension[0].heightMax,
          //   type: "error",
          //   // position: "top-right",
          //   // all of other options may go here
          // });
        }
      }
    },
    changeDetailProduct(element, index) {
      this.colorImg = element.couleur;
      this.getImage(element.image[0]);
      console.log(index);
      if (this.detailsElement.typeArticle == "vetements") {
        this.detailsElementSize = this.detailsElement.vetements[
          index
        ].tailleEtQuantites;
        this.subId = this.detailsElement.vetements[index]._id;
      } else if (this.detailsElement.typeArticle == "chaussure") {
        this.detailsElementPointure = this.detailsElement.chaussure[
          index
        ].pointureEtQuantites;
        this.subId = this.detailsElement.chaussure[index]._id;
      } else if (this.detailsElement.typeArticle == "tapis") {
        this.detailsElementDimmension = this.detailsElement.tapis[
          index
        ].widthAndHeight;
        this.maxH = this.detailsElementDimmension[0].heightMax;
        this.maxW = this.detailsElementDimmension[0].widthMax;
        if (this.detailsElementDimmension[0].quantite == 0) {
          this.quantiteMax = 0;
          this.quantiteMin = 0;
        } else {
          this.quantiteMax = this.detailsElementDimmension[0].quantite;
        }
        this.subId = this.detailsElement.tapis[index]._id;
      } else if (this.detailsElement.typeArticle == "autre") {
        this.detailsElementDimmension = this.detailsElement.autre[
          index
        ].quantites;
        if (this.detailsElementDimmension[0].quantite == 0) {
          this.quantiteMax = 0;
          this.quantiteMin = 0;
        } else {
          this.quantiteMax = this.detailsElementDimmension[0].quantite;
        }
        this.subId = this.detailsElement.autre[index]._id;
      }
    },
    verifImg(img) {
      if (
        img.includes(
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/undefined"
        )
      ) {
        return false;
      } else {
        return true;
      }
    },
    getImage(img) {
      if (
        img.includes(
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/"
        )
      ) {
        this.modelImage0 = img;
      } else {
        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          img;
      }
    },

    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    getSizeChange() {
      this.detailsElementSize.forEach((element) => {
        if (element._id == this.selectDetailsSize) {
          if (element.quantite == 0) {
            this.quantiteMax = 0;
            this.quantiteMin = 0;
          } else {
            console.log("true");
            this.quantiteMax = element.quantite;
          }
          if (element.quantite > 0) {
            this.modelDisponible = "Disponible";
          } else {
            this.modelDisponible = "Précommander";
          }
        } else {
          console.log("false");
        }
      });
    },
    pointureChange(element) {
      console.log(element);
      return element.pointure;
    },
    getpointureChange() {
      this.detailsElementPointure.forEach((element) => {
        console.log(element.quantite);
        if (element._id == this.idSelectedElement) {
          if (element.quantite == 0) {
            this.quantiteMax = 0;
            this.quantiteMin = 0;
          } else {
            this.quantiteMax = element.quantite;
          }
          if (element.quantite > 0) {
            this.modelDisponible = "Disponible";
          } else {
            this.modelDisponible = "Précommander";
          }
        } else {
          console.log("false");
        }
      });
    },
    sizeChange(element) {
      console.log(element);
      return element.taille;
    },
    modelContent() {
      var element = this.$store.state.product.productDetail;
      console.log(element);
      this.idSelectedElement = element._id;
      this.detailsElement = element;
      if (this.detailsElement.typeArticle == "vetements") {
        this.subid = element.vetements[0]._id;
        this.colorImg = element.vetements[0].couleur;
        this.selectDetailsSize =
          element.vetements[0].tailleEtQuantites[0].taille;
        this.detailsElementSize = element.vetements[0].tailleEtQuantites;
        this.quantiteMax = element.vetements[0].tailleEtQuantites[0].quantite;
        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[2];

        if (element.disponibility) {
          if (
            new Date(element.disponibility[0]) > new Date() ||
            element.vetements[0].tailleEtQuantites[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (element.vetements[0].tailleEtQuantites[0].quantite > 0) {
          this.modelDisponible = "Disponible";
        }
      } else if (this.detailsElement.typeArticle == "chaussure") {
        this.subid = element.chaussure[0]._id;
        this.colorImg = element.chaussure[0].couleur;
        this.selectDetailsPointure =
          element.chaussure[0].pointureEtQuantites[0].pointure;
        this.detailsElementPointure = element.chaussure[0].pointureEtQuantites;
        this.quantiteMax = element.chaussure[0].pointureEtQuantites[0].quantite;

        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[2];

        if (element.disponibility) {
          if (
            new Date(element.disponibility[0]) > new Date() ||
            element.chaussure[0].pointureEtQuantites[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (element.chaussure[0].pointureEtQuantites[0].quantite > 0) {
          this.modelDisponible = "Disponible";
        }
      } else if (this.detailsElement.typeArticle == "tapis") {
        this.subid = element.tapis[0]._id;
        this.colorImg = element.tapis[0].couleur;
        this.detailsElementDimmension = this.detailsElement.tapis[0].widthAndHeight;
        this.maxH = this.detailsElementDimmension[0].heightMax;
        this.maxW = this.detailsElementDimmension[0].widthMax;
        this.quantiteMax = element.tapis[0].widthAndHeight[0].quantite;

        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[2];

        if (element.disponibility) {
          if (
            new Date(element.disponibility[0]) > new Date() ||
            element.tapis[0].widthAndHeight[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (element.tapis[0].widthAndHeight[0].quantite > 0) {
          this.modelDisponible = "Disponible";
        }
      } else if (this.detailsElement.typeArticle == "autre") {
        this.subid = element.autre[0]._id;
        this.colorImg = element.autre[0].couleur;
        this.quantiteMax = element.autre[0].quantites[0].quantite;

        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[2];

        if (element.disponibility) {
          if (
            new Date(element.disponibility[0]) > new Date() ||
            element.autre[0].quantites[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (element.autre[0].quantites[0].quantite > 0) {
          this.modelDisponible = "Disponible";
        }
      }

      this.modelDescription = element.description;
      this.modelPrice = this.numberWithSpaces(element.productPrice);
      // this.modelPrice=element.price
      this.modelTitle = element.label;
      this.btnValue = element.orderType;
    },
    imgColor(img) {
      return (
        "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" + img
      );
    },
    GetProductNumber() {
      //extracting the theme number from local storage
      if (localStorage.getItem("ProductNumber") === null) {
        return 0;
      } else {
        return localStorage.getItem("ProductNumber");
      }
    },

    addedElement(id) {
      var ProNum = this.GetProductNumber();
      var idElement;
      for (let i = 1; i <= ProNum; i++) {
        idElement = JSON.parse(localStorage.getItem("product" + i));
        if (idElement.productId == id) {
          return false;
        }
      }
      return true;
    },
    deleteArticle(id) {
      var TabThemes = [];
      var nb = this.GetProductNumber();
      window.localStorage.removeItem("ProductNumber");
      var idElement;
      for (var k = 1; k <= nb; k++) {
        idElement = JSON.parse(localStorage.getItem("product" + k));
        if (idElement.productId != id) {
          TabThemes.push(JSON.stringify(idElement));
        }
        window.localStorage.removeItem("product" + k);
      }
      for (var j = 1; j <= TabThemes.length; j++) {
        localStorage.setItem("product" + j, TabThemes[j - 1]);
      }
      localStorage.setItem("ProductNumber", TabThemes.length);
      this.$toast.open({
        message: "Produit supprimé au Panier",
        type: "success",
      });
      this.$store.commit("setbasket", TabThemes);
    },
    addArticle(id, subid) {
      console.log(id, subid);
      let ProNum = this.GetProductNumber();
      var TabThemes = [];
      ProNum++;
      var product;
      console.log("add panier", this.detailsElement);
      if (this.detailsElement.typeArticle == "vetements") {
        product = {
          image: this.detailsElement.vetements[0].image[0],
          label: this.detailsElement.label,
          productPrice: this.detailsElement.productPrice,
          type: this.detailsElement.typeArticle,
          quantite: parseInt(this.model.quantite),
          taille: this.selectDetailsSize,
          color: this.colorImg,
          productId: id,
          vetements: {
            _id: this.subid,
          },
        };
      } else if (this.detailsElement.typeArticle == "chaussure") {
        product = {
          image: this.detailsElement.chaussure[0].image[0],

          label: this.detailsElement.label,
          productPrice: this.detailsElement.productPrice,
          type: this.detailsElement.typeArticle,
          quantite: parseInt(this.model.quantite),
          pointure: this.selectDetailsPointure,
          color: this.colorImg,
          productId: id,
          chaussure: {
            _id: this.subid,
          },
        };
      } else if (this.detailsElement.typeArticle == "tapis") {
        product = {
          image: this.detailsElement.tapis[0].image[0],
          label: this.detailsElement.label,
          productPrice: this.detailsElement.productPrice,
          type: this.detailsElement.typeArticle,
          quantite: parseInt(this.model.quantite),
          widthMax: this.dimmensionLargeur,
          heightMax: this.dimmensionLongueur,
          color: this.colorImg,
          productId: id,
          tapis: {
            _id: this.subid,
          },
        };
      } else if (this.detailsElement.typeArticle == "autre") {
        product = {
          image: this.detailsElement.autre[0].image[0],
          label: this.detailsElement.label,
          productPrice: this.detailsElement.productPrice,
          type: this.detailsElement.typeArticle,
          quantite: parseInt(this.model.quantite),
          color: this.colorImg,
          productId: id,
          autre: {
            _id: this.subid,
          },
        };
      }
      console.log("product", product);
      localStorage.setItem("ProductNumber", ProNum);
      localStorage.setItem("product" + ProNum, JSON.stringify(product));
      console.log(
        "object",
        JSON.parse(localStorage.getItem("product" + ProNum))
      );
      this.$toast.open({
        message: "Produit bien ajouté au Panier",
        type: "success",
      });
      for (var k = 1; k <= ProNum; k++) {
        TabThemes.push(localStorage.getItem("product" + k));
      }
      this.$store.commit("setbasket", TabThemes);
    },
    productBtnMore() {
      if (this.allArticles.length > this.pageSize) {
        return true;
      } else {
        return false;
      }
    },
  },
};
